import { IAxiosResponse } from '../store/ducks/root.types'
import axiosInstance from './axios'
import { PotentialPatient, PromotionStatus } from '../store/application/models/potential.patient/potentialPatient'
import { IPaginatorModified } from '../store/ducks/active.search/types'

class ActiveSearchService {

  constructor(private apiVersion: string = 'v1') { }

  /**
   * @abstract Returns all potential patients in active search
   * @param {IPaginatorModified} paginator                     
   * @returns {Promise<PotentialPatient[]>}
   */
  public async getAll(
    paginator?: IPaginatorModified
  ): Promise<IAxiosResponse<PotentialPatient[]>> {
    const params: URLSearchParams = this.buildParams(paginator)
    return axiosInstance
      .get(`${this.apiVersion}/form`, {
        params,
        headers: {
          'api-key': `${process.env.REACT_APP_API_KEY}`
        }
      })
      .then((response) => {
        return {
          data: response.data.map((data: PotentialPatient) => new PotentialPatient().fromJSON(data)),
          headers: response.headers
        }
      })
  }

  /**
   * @abstract Returns a potential patient by id
   * @param patientId 
   * @returns {Promise<PotentialPatient>}
   */
  public async getById(patientId: string): Promise<IAxiosResponse<PotentialPatient>> {
    return axiosInstance
      .get(`${this.apiVersion}/form/${patientId}`)
      .then((response) => {
        return {
          data: new PotentialPatient().fromJSON(response.data),
          headers: response.headers
        }
      })
  }

  /**
   * @abstract Removes a potential patient from active search
   * @param patientId     
   * @returns {Promise<PotentialPatient>}
   */
  public async remove(patientId: string): Promise<IAxiosResponse<PotentialPatient>> {
    return axiosInstance
      .delete(`${this.apiVersion}/form/${patientId}`)
      .then((response) => {
        return {
          data: new PotentialPatient().fromJSON(response.data),
          headers: response.headers
        }
      })
  }

  /**
   * @abstract Promotes a potential patient from active search to registered patient
   * @param {string} patientId 
   * @returns {Promise<PotentialPatient>} data 
   */
  public async promote(patientId: string): Promise<IAxiosResponse<PotentialPatient>> {
    return axiosInstance
      .patch(`${this.apiVersion}/form/${patientId}/promote`)
      .then((response) => {
        return {
          data: new PotentialPatient().fromJSON(response.data),
          headers: response.headers
        }
      })
  }

  /**
   * @abstract Rejects a potential patient from active search
   * @param patientId 
   * @returns {Promise<PotentialPatient>} data 
   */
  public async reject(patientId: string): Promise<IAxiosResponse<PotentialPatient>> {
    return axiosInstance
      .patch(`${this.apiVersion}/form/${patientId}/reject`)
      .then((response) => {
        return {
          data: new PotentialPatient().fromJSON(response.data),
          headers: response.headers
        }
      })
  }


  public buildParams(paginator?: IPaginatorModified): URLSearchParams {
    const params = new URLSearchParams()
    params.append('promotion_status', PromotionStatus.PENDING)
    if (paginator) {

      if (paginator.page) {
        params.append('page', String(paginator.page + 1))
      }
      if (paginator.rows) {
        params.append('limit', String(paginator.rows))
      }
    }
    // Filtros adicionais
    if (paginator?.search) {
      if (paginator?.search?.state) {
        params.append('address.state', `*${paginator.search.state}*`)
      }
      if (paginator?.search?.city) {
        params.append('address.city', `*${paginator.search.city}*`)
      }
    }

    return params
  }
}
const activeSearchService = new ActiveSearchService()

export default activeSearchService